// extracted by mini-css-extract-plugin
export default {"MychatsWrapper":"Mychats_MychatsWrapper__3oRLG","personsWrapper":"Mychats_personsWrapper__X+ooC"};